import '../../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../../node_modules/slick-carousel/slick/slick-theme.css';

import { Box, Typography } from '@mui/material';
import { Listing, useListingsSearchRecentLazyQuery } from 'graphql/generated';
import React from 'react';
import Slider from 'react-slick';

import RecentListingView from './RecentListingView';

type Props = {};

const RecentListings = (props: Props) => {
  const [runOnce, runOnceTo] = React.useState(true);
  const [loadRecents] = useListingsSearchRecentLazyQuery();
  const [listings, listingsTo] = React.useState<Partial<Listing[]>>([]);
  const slickSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  React.useEffect(() => {
    if (runOnce) {
      runOnceTo(false);
      // code
      const runQuery = async () => {
        const { data } = await loadRecents({ variables: { count: 9 } });
        if (data?.listingsSearchRecent) {
          listingsTo(data.listingsSearchRecent);
        }
      };
      runQuery();
    }
  }, [runOnce, loadRecents]);

  return (
    <div>
      <Slider {...slickSettings}>
        {listings.map(x => (
          <Box key={x?.id} p={0.5}>
            <RecentListingView listing={x} />
          </Box>
        ))}
      </Slider>
    </div>
  );
};

export default RecentListings;
